import {CustomerRowInterface} from "./CustomerRowInterface";
import {useNavigate} from "react-router-dom";
import moment from "moment";

export const CustomerRow = (props: CustomerRowInterface) => {
    const navigate = useNavigate();
    
    return (
        <tr onClick={()=> navigate(`/customers/${props.customer.id}/edit`)}>
            <td>{props.index}</td>
            <td>{props.customer.name}</td>
            <td>
                <input
                    disabled={true}
                    type={"checkbox"}
                    defaultChecked={props.customer.active} />
            </td>
            <td>{props.customer.created && 
                moment(props.customer.created, moment.ISO_8601)?.format('YYYY-MM-DD HH:mm:ss')}</td>
            <td>{props.customer.lastModified && 
                moment(props.customer.lastModified, moment.ISO_8601)?.format('YYYY-MM-DD HH:mm:ss')}</td>
        </tr>
    )
}
